module.exports = __webpack_public_path__ + "static/mysa-mattress-intro-e212ebbadb72131ce5e71da13b616dca.mp4";